<y42-text-input
  [formCtrl]="formCtrl"
  [label]="label"
  [type]="state.hiddenPassword ? 'password' : 'text'"
  [required]="required"
  [errorMessages]="errorMessages"
  [color]="color"
  [tooltipHint]="tooltipHint"
  [hideErrors]="hideErrors"
  [autocomplete]="autocomplete"
  [placeholder]="placeholder"
>
  <ng-container dojoInputSuffix>
    <dojo-icon-button
      tabindex="-1"
      (click)="togglePasswordVisibility()"
      [icon]="state.hiddenPassword ? 'eye' : 'eye-slash'"
      [iconSize]="16"
    ></dojo-icon-button>
  </ng-container>
</y42-text-input>
